// extracted by mini-css-extract-plugin
export default {"education":"Education_education__Ckzqq","list":"Education_list__G3iBR","item":"Education_item__vrfZK","meta":"Education_meta__P92-l"};